// extracted by mini-css-extract-plugin
module.exports = {"ForumSearch__headline":"pr_a bha_rh bha_tu","ForumSearch__img":"pr_b","ForumSearch__searchAdsAndShoppingAds":"pr_c","ForumSearch__results--empty":"pr_e"};